import AbstractSpecification from "../specification/AbstractSpecification.js";

/**
 * `accountIntervalSpecification` is a concrete implementation
 * of `abstractSpecification` representing a server side
 * specification of a range of accounts.
 *
 * @param {string} interval - Account interval
 */
export default class AccountIntervalSpecification extends AbstractSpecification {
	constructor({ interval = "" } = {}) {
		super(...arguments);
		this._interval = interval;
	}

	getInterval() {
		return this._interval;
	}

	accept(visitor, additionalInformation) {
		return visitor.visitAccountIntervalSpecification(
			this,
			additionalInformation,
		);
	}

	isLeaf() {
		return true;
	}

	isAccountIntervalSpecification() {
		return true;
	}

	_serializedProperties() {
		const schema = super._serializedProperties();

		schema.interval = this._interval;

		return schema;
	}

	static getType() {
		return "AccountIntervalSpecification";
	}
}
